import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianCurrency'
})
export class IndianCurrencyPipe implements PipeTransform {

  transform(value: number | string, currencySymbol: string = '₹'): string {
    if (value == null || value === '') return '';

    const numberValue = typeof value === 'string' ? parseFloat(value) : value;

    const x = numberValue.toFixed(2).split('.');
    let integerPart = x[0];
    const decimalPart = x[1];

    // Regex to add commas in Indian numbering format
    const lastThree = integerPart.substring(integerPart.length - 3);
    const otherNumbers = integerPart.substring(0, integerPart.length - 3);
    if (otherNumbers !== '') {
      integerPart = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    return `${currencySymbol}${integerPart}.${decimalPart}`;
  }
}
